import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {Doughnut} from 'react-chartjs'
import config from '../../config'
import format from '../../helpers/format'

import Styles from './TargetDateSeriesDoughnutChart.css'

/**
 *
 * Displays the doughnut chart and taglines for the selected issue.
 *
 *
 * Depending on which of the target date series is selected; as well as which
 * of the six allowed issues is selected; it will show different:
 *
 * - chart
 * - list of sentences describing exposure for different risk sectors
 *
 * (GEF does not have a doughnut chart.)
 *
 */
@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateSeriesDoughnutChart extends Component {
  static propTypes = {
    // three letters, fff/dff/gef/gff/pff/wff/tff
    iyvCode: PropTypes.string.isRequired,
    // the target date series object
    targetDateSeries: PropTypes.object.isRequired,
  }
  constructor(props) {
    super(props)

    const { iyvCode, targetDateSeries } = props

    let chartData = null
    let taglines = null
    switch (iyvCode) {
      case 'fff':
        chartData = [
          {
            value: targetDateSeries.fossil_fuel_weight * 100.0,
            label: 'Fossil fuel companies',
            color: '#333333'
          },
          {
            value: (1 - targetDateSeries.fossil_fuel_weight) * 100.0,
            label: 'Other',
            color: '#CCCCCC'
          }
        ]
        taglines = [
          (
          <span>
            <b>{format.perc(targetDateSeries.fossil_fuel_weight)}</b> invested in
            fossil fuels.
          </span>
          ),
        ]
        break

      case 'dff':
        chartData = [
          {
            value: targetDateSeries.df_all_weight * 100.0,
            label: 'Deforestation-risk screens',
            color: '#333333'
          },
          {
            value: (1 - targetDateSeries.df_all_weight) * 100.0,
            label: 'Other',
            color: '#CCCCCC'
          }
        ]
        taglines = [
          (
          <span>
            <b>{format.perc(targetDateSeries.df_p_weight)}</b> invested in
            deforestation-risk agribusiness.
          </span>
          ),
          (
          <span>
            <b>{format.perc(targetDateSeries.df_f_weight)}</b> invested in
            deforestation-risk finance.
          </span>
          ),
          (
          <span>
            <b>{format.perc(targetDateSeries.df_c_weight)}</b> invested in
            deforestation-risk consumer brands.
          </span>
          ),
        ]
        break

      case 'ffb':
        chartData = [
          {
            value: targetDateSeries.fossil_bank_weight * 100.0,
            label: 'Fossil fuel lenders & underwriters',
            color: '#333333'
          },
          {
            value: (1 - targetDateSeries.fossil_bank_weight) * 100.0,
            label: 'Other',
            color: '#CCCCCC'
          }
        ]
        taglines = [
          (
          <span>
            <b>{format.perc(targetDateSeries.fossil_bank_weight)}</b> invested in
            fossil fuel lenders & underwriters.
          </span>
          ),
        ]
        break

      case 'ffi':
        chartData = [
          {
            value: targetDateSeries.fossil_insure_weight * 100.0,
            label: 'Fossil fuel insurers',
            color: '#333333'
          },
          {
            value: (1 - targetDateSeries.fossil_insure_weight) * 100.0,
            label: 'Other',
            color: '#CCCCCC'
          }
        ]
        taglines = [
          (
          <span>
            <b>{format.perc(targetDateSeries.fossil_insure_weight)}</b> invested in
            fossil fuel insurers.
          </span>
          ),
        ]
        break

      // case 'gef':
      //   break

      case 'gff':
        chartData = [
          {
            value: targetDateSeries.wff_gun_manufacturers_weight * 100.0,
            label: 'Gun manufacturers',
            color: '#333333'
          },
          {
            value: targetDateSeries.wff_gun_retailers_weight * 100.0,
            label: 'Gun retailers',
            color: '#333333'
          },
          {
            value: (1 - targetDateSeries.wff_civ_weight) * 100.0,
            label: 'Other',
            color: '#CCCCCC'
          }
        ]
        taglines = [
          (
          <span>
            <b>
              {format.perc(targetDateSeries.wff_gun_manufacturers_weight)}
            </b> invested in gun manufacturers.
          </span>
          ),
          (
          <span>
            <b>
              {format.perc(targetDateSeries.wff_gun_retailers_weight)}
            </b> invested in gun retailers.
          </span>
          ),
        ]
        break

      case 'pff':
        chartData = [
          {
            value: targetDateSeries.pff_all_weight * 100.0,
            label: 'Prison industrial complex screen',
            color: '#333333'
          },
          {
            value: (1 - targetDateSeries.pff_all_weight) * 100.0,
            label: 'Other',
            color: '#CCCCCC'
          }
        ]
        taglines = [
          // (
          // <span>
          //   <b>{format.perc(targetDateSeries.pff_extreme_weight)}</b> invested
          //   in private prison operators screen.
          // </span>
          // ),
          // (
          // <span>
          //   <b>{format.perc(targetDateSeries.pff_high_weight)}</b> invested in
          //   higher-risk prison industrial complex screen.
          // </span>
          // ),
          (
          <span>
            <b>{format.perc(targetDateSeries.pff_all_weight)}</b> invested in
            companies involved in the prison industrial complex.
          </span>
          ),
        ]
        break

      case 'wff':
        chartData = [
          {
            value: targetDateSeries.wff_mil_weight * 100.0,
            label: 'Military weapons screen',
            color: '#333333'
          },
          {
            value: (1 - targetDateSeries.wff_mil_weight) * 100.0,
            label: 'Other',
            color: '#CCCCCC'
          }
        ]
        taglines = [
          // (
          // <span>
          //   <b>
          //     {format.perc(targetDateSeries.wff_nuclear_weapons_weight)}
          //   </b> invested in companies involved with nuclear weapons.
          // </span>
          // ),
          // (
          // <span>
          //   <b>
          //     {format.perc(targetDateSeries.wff_cluster_munitions_weight)}
          //   </b> invested in companies involved with controversial weapons.
          // </span>
          // ),
          (
          <span>
            <b>
              {
                format.perc(
                  targetDateSeries.wff_major_military_contractors_weight
                )
              }
            </b> invested in military contractors.
          </span>
          ),
        ]
        break

      case 'tff':
        chartData = [
          {
            value: targetDateSeries.t_weight * 100.0,
            label: 'Tobacco producers companies',
            color: '#333333'
          },
          {
            value: targetDateSeries.t_m_weight * 100.0,
            label: 'Tobacco-promoting entertainment companies',
            color: '#333333'
          },
          {
            value: (1 - targetDateSeries.t_all_weight) * 100.0,
            label: 'Other',
            color: '#CCCCCC'
          }
        ]
        taglines = [
          (
          <span>
            <b>{format.perc(targetDateSeries.t_weight)}</b> invested in
            tobacco producers.
          </span>
          ),
          (
          <span>
            <b>{format.perc(targetDateSeries.t_m_weight)}</b> invested in
            tobacco-promoting entertainment companies.
          </span>
          ),
        ]
        break
    }

    this.state = {
      chartData,
      taglines
    }
  }

  //
  render() {
    const { chartData, taglines } = this.state
    if (!chartData || !taglines) { return null }

    //
    return (
      <div styleName='doughnut-flex'>
        <div styleName='doughnut-flex-doughnut'>
          <Doughnut
            data={chartData}
            options={config.chartOptions}
            width='100'
            height='100'
          />
        </div>
        <div styleName='doughnut-flex-content'>
          <div>
            {
              taglines.map((e, i) => {
                return (
                  <div
                    key={'doughnut-tagline-' + i}
                    styleName='doughnut-flex-content-text'
                  >
                    {e}
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    )
  }
}